(() => {
  const money = (cents, currency) => { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100); } catch (_) { return `$${(cents / 100).toFixed(2)}`; } };
  const styleImages = {
    "hoodie": {
      "Creamy White": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/S971c9b1c1190460a83daee8fce6b45e4f.webp?v=1789443727",
      "Pink": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/S7f1401037b44425091432a0ce6026cd45.webp?v=1789443727",
      "Khaki": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/S10bb3d9b14d6495aacbad16a552f04f9s.webp?v=1789443727",
      "Grey": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/Sf08a0aeecd904365a5b4d0216e723fdft.webp?v=1789443727",
      "Sky Blue": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/Sfe61f1ff57744d3a823828e892c19836y.webp?v=1789443727",
      "Black": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/Sf56abfab42ce4501b27043e5140ca823P.webp?v=1789443728"
    },
    "crewneck": {
      "Black": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/S5fd3c456a401401bb4010a15bb1137c15.webp?v=1789443728",
      "White": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/S229d400fd3dc43c09d1a868c91c2c29aj.webp?v=1789443728",
      "Navy": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/Sfc21bf1f8fa24097a851b19df5e5e4b8T.webp?v=1789443728",
      "Light Gray": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/Sf8c102d57c8340dd9c3dac777d27637eX.webp?v=1789443728",
      "Dark Gray": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/S781efdc64e7f48baba9fb64e45944e57c.webp?v=1789443728",
      "Coffee": "https://cdn.shopify.com/s/files/1/1001/1810/2335/files/Sf67ad487fd014f46ac865396ab9405b7Y.webp?v=1789443729"
    }
  };
  const init = (section) => {
    if (section.dataset.pawPouchReady) return; section.dataset.pawPouchReady = 'true';
    const data = [...section.querySelectorAll('[data-product-variants]')]; const form = section.querySelector('.paw-pouch__form'); if (!data.length || !form) return;
    const products = Object.fromEntries(data.map((item) => [item.dataset.productKey || 'hoodie', JSON.parse(item.textContent || '[]')])); const idInput = form.querySelector('[data-variant-id]'); const price = section.querySelector('[data-product-price]'); const addPrice = form.querySelector('[data-add-price]'); const addLabel = form.querySelector('[data-add-label]'); const addButton = form.querySelector('[data-add-button]'); const currency = section.dataset.currency || 'USD';
    const qtyInput = form.querySelector('[data-bundle-quantity-input]'); const bundleCards = [...form.querySelectorAll('[data-bundle-qty]')]; const compareEl = section.querySelector('[data-save-badge]');
    const eligibleVariants = new Set(data.filter(item => ['10632059191615', '10632059224383'].includes(item.dataset.productId)).flatMap(item => (products[item.dataset.productKey || 'hoodie'] || []).map(variant => variant.id)));
    const saveTemplate = section.dataset.bundleSaveTemplate || 'Save [amount]';
    let currentVariant = null;
    const bundleQty = () => { const checked = form.querySelector('[data-bundle-qty]:checked'); return checked ? Number(checked.value) : 1; };
    const updateBundleDisplays = () => {
      if (!currentVariant) return;
      const unitPrice = currentVariant.price; const unitCompare = currentVariant.compare_at_price;
      const pairDiscount = currency === 'USD' && eligibleVariants.has(currentVariant.id) ? Math.min(999, unitPrice) : 0;
      const bundleSaving = qty => Math.floor(qty / 2) * pairDiscount;
      const bundleTotal = qty => unitPrice * qty - bundleSaving(qty);
      const offer = section.querySelector('[data-bundle-offer]');
      if (offer) offer.hidden = !(pairDiscount && unitPrice === 5499);
      bundleCards.forEach((input) => {
        const qty = Number(input.value); const card = input.closest('.paw-pouch__bundle-card'); if (!card) return;
        const totalEl = card.querySelector('[data-bundle-total]'); if (totalEl) totalEl.textContent = money(bundleTotal(qty), currency);
        const saveEl = card.querySelector('[data-bundle-save]');
        if (saveEl) { saveEl.textContent = saveTemplate.replace('[amount]', money(bundleSaving(qty), currency)); saveEl.hidden = bundleSaving(qty) === 0; }
      });
      const qty = bundleQty();
      if (qtyInput) qtyInput.value = String(qty);
      if (addPrice) addPrice.textContent = money(bundleTotal(qty), currency);
      if (compareEl) { if (unitCompare && unitCompare > unitPrice) { compareEl.textContent = `Save ${money((unitCompare - unitPrice) * qty, currency)} ♡`; compareEl.hidden = false; } else { compareEl.hidden = true; } }
    };
    const main = section.querySelector('.paw-pouch__main-image');
    const thumbs = section.querySelector('.paw-pouch__thumbs');
    const optionFields = [...form.querySelectorAll('select[data-option-position]')];
    const originalOptions = new Map(optionFields.map(field => [field, [...field.options].map(option => option.value)]));
    const normalize = value => String(value || '').trim().toLowerCase();
    let galleryStyle = '';
    const showImage = (src, alt) => {
      if (!main || !src) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      main.alt = alt || main.alt;
      section.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        const active = thumb.dataset.image.split('?')[0] === src.split('?')[0];
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    const updateGallery = style => {
      if (galleryStyle === style || !styleImages[style] || !thumbs) return;
      galleryStyle = style;
      const template = thumbs.querySelector('[data-gallery-thumb]');
      if (!template) return;
      const buttons = Object.entries(styleImages[style]).map(([color, src], index) => {
        const button = template.cloneNode(true);
        button.dataset.image = src;
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', color + ' ' + style);
        const image = button.querySelector('img');
        if (image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = src + (src.includes('?') ? '&' : '?') + 'width=180';
          image.alt = color + ' ' + style;
        }
        return button;
      });
      thumbs.replaceChildren(...buttons);
    };
    const updateVariant = () => {
      const productChoice = form.querySelector('input[data-product-key]:checked');
      const productKey = productChoice?.dataset.productKey || 'hoodie';
      const variants = products[productKey] || [];
      const chosen = {};
      const radios = [...form.querySelectorAll('input[data-option-position]:checked')];
      radios.forEach(field => { chosen[Number(field.dataset.optionPosition) - 1] = field.value; });
      let candidates = variants.filter(variant => Object.entries(chosen).every(([position, value]) => variant.options[position] === value));
      optionFields.sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).forEach(field => {
        const position = Number(field.dataset.optionPosition) - 1;
        const availableValues = [...new Set(candidates.map(variant => variant.options[position]).filter(value => value != null))];
        const ordered = [...originalOptions.get(field).filter(value => availableValues.includes(value)), ...availableValues.filter(value => !originalOptions.get(field).includes(value))];
        const previous = field.value;
        field.replaceChildren(...ordered.map(value => new Option(value, value)));
        field.value = ordered.includes(previous) ? previous : (ordered[0] || '');
        field.disabled = ordered.length === 0;
        chosen[position] = field.value;
        candidates = candidates.filter(variant => variant.options[position] === field.value);
      });
      const variant = candidates.find(item => item.options.every((value, position) => chosen[position] === value));
      currentVariant = variant || null;
      if (!variant) {
        idInput.value = '';
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = String(variant.id);
      price.textContent = money(variant.price, currency);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart ♡' : 'Sold out';
      const style = normalize(radios.find(field => styleImages[normalize(field.value)])?.value || productKey);
      const color = variant.options.find(value => styleImages[style]?.[value]);
      updateGallery(style);
      const src = variant.featured_image?.src || variant.featured_image?.url || styleImages[style]?.[color] || productChoice?.dataset.productImage;
      showImage(src, [color, style].filter(Boolean).join(' '));
      if (productChoice?.dataset.productTitle) {
        const title = section.querySelector('[data-product-title]');
        if (title) title.textContent = productChoice.dataset.productTitle;
      }
      const compare = section.querySelector('.paw-pouch__compare');
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        const amount = compare.querySelector('s');
        if (amount && !compare.hidden) amount.textContent = money(variant.compare_at_price, currency);
      }
      updateBundleDisplays();
    };
    form.addEventListener('change', event => {
      if (event.target.matches('[data-bundle-qty]')) updateBundleDisplays();
      else updateVariant();
    });
    section.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb && section.contains(thumb)) showImage(thumb.dataset.image, thumb.querySelector('img')?.alt);
    });
    updateVariant();
  };
  document.querySelectorAll('[data-paw-pouch-section]').forEach(init); document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-paw-pouch-section]').forEach(init));
})();
